import { render, staticRenderFns } from "./addShortcutForm.vue?vue&type=template&id=85248eb4&"
import script from "./addShortcutForm.vue?vue&type=script&lang=js&"
export * from "./addShortcutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports